// import { tlPlayPause } from "./utils";

import { comingControlKey } from "./page-coming-soon";
import { errorControlKey } from "./page-error";

import { hoheControlKey } from "./page-home-hero";
import { howeControlKey } from './page-home-web';
import { hoemControlKey } from "./page-home-email";
import { hophControlKey } from "./page-home-photo";
import { hocoControlKey } from "./page-home-contact";


export const controlKeyHandler = (e) => {
  if(e.key === '0') {
    comingControlKey(e.key);
    errorControlKey(e.key);
  }
  if(e.key === '1') hoheControlKey(e.key);  
  if(e.key === '2') howeControlKey(e.key);
  if(e.key === '3') hoemControlKey(e.key);
  if(e.key === '5') hophControlKey(e.key);
  if(e.key === '7') hocoControlKey(e.key);

}